// パソコンデスク: フラットな天板と脚のシンプルなデスク
import { Box } from '@react-three/drei'

export default function PCDeskMesh({ width, height, depth, position, color, isSelected }) {
    // 脚: 高さの85%（下部）
    const legHeight = height * 0.85
    const legThickness = width * 0.04
    // 天板: 高さの15%（上部）
    const topThickness = height * 0.15
    const topY = position[1] + height / 2 - topThickness / 2
    const legY = position[1] - height / 2 + legHeight / 2

    const legPositions = [
        [-width / 2 + legThickness, legY, -depth / 2 + legThickness],
        [width / 2 - legThickness, legY, -depth / 2 + legThickness],
        [-width / 2 + legThickness, legY, depth / 2 - legThickness],
        [width / 2 - legThickness, legY, depth / 2 - legThickness],
    ]

    return (
        <group>
            {/* 天板 */}
            <Box args={[width, topThickness, depth]} position={[0, topY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 脚 */}
            {legPositions.map((pos, i) => (
                <Box key={i} args={[legThickness, legHeight, legThickness]} position={pos}>
                    <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
                </Box>
            ))}

            {/* ワイヤーフレーム - 天板 */}
            <Box args={[width, topThickness, depth]} position={[0, topY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 脚 */}
            {legPositions.map((pos, i) => (
                <Box key={`wire-${i}`} args={[legThickness, legHeight, legThickness]} position={pos}>
                    <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
                </Box>
            ))}

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
